import { useEffect, useState, useContext, useRef } from 'react';

import {
  universalReferenceActions,
  RefValueItemInterface,
} from '../../../universal-reference/store/universalReferenceStore';
import { SimpleCheckboxInput, FormContext, FormContextType } from '../forms';

interface RefValueListSelectorProps {
  label?: string,
  refId: number
  int1?: number,
  filterKey?: Array<number>, // фильтр по определённым ключам, которые нужно показать
  excludeKey?: Array<number>, // фильтр по ключам, которые надо исключить
  name: string,
  defaultChecked?: boolean, // значение галочек по умолчанию
  sort?: boolean, // отсортировать значения по полю Sort
}

const RefValueListSelector = (props: RefValueListSelectorProps) => {
  const {
    refId,
    int1,
    filterKey,
    excludeKey,
    name,
    label,
    defaultChecked,
    sort,
  } = props;

  const [loading, setLoading] = useState(false);
  const [refValues, setRefValues] = useState<Array<RefValueItemInterface & { checked?: boolean }>>([]);
  const { setFieldValue, values } = useContext<FormContextType>(FormContext);
  const hasProcessedRefValues = useRef(false);

  // далее фильтранём список значений, если заданы фильтры в параметрах
  let filteredRefValues = [...refValues];
  if (int1) {
    filteredRefValues = filteredRefValues.filter((v) => String(v.int1) === String(int1));
  }
  if (filterKey) {
    filteredRefValues = filteredRefValues.filter((v) => filterKey.find((k) => v.id === k));
  }
  if (excludeKey) {
    filteredRefValues = filteredRefValues.filter((v) => !(excludeKey.find((k) => v.id === k)));
  }
  if (sort) {
    filteredRefValues = filteredRefValues.sort((a, b) => ((a.sort as number) ?? 0) - ((b.sort as number) ?? 0));
  }

  useEffect(() => {
    let isSubscribed = true;

    setLoading(true);
    // экшен стора кэширует значения по refId на сессию — повторные mount'ы идут без запроса
    universalReferenceActions.getRefValues(refId)
      .then((refValues) => isSubscribed && setRefValues(refValues.map((v) => {
        return {
          ...v,
          checked: ((values[name])
            ? !!values[name].find((k) => k === v.id)
            : null) ?? defaultChecked ?? false,
        };
      })))
      .finally(() => isSubscribed && setLoading(false));
    return () => { isSubscribed = false; };
  }, [refId, defaultChecked, values, name]);

  useEffect(() => {
    // Срабатывает только когда refValues изменился и мы еще не обрабатывали его
    if (refValues.length > 0 && defaultChecked && !hasProcessedRefValues.current) {
      const refValuesToSet = refValues.map((k) => {
        return { ...k, checked: defaultChecked };
      });

      setFieldValue(name, refValuesToSet.filter((k) => k.checked).map((l) => l.id));
      hasProcessedRefValues.current = true; // Помечаем, что обработали
    }
  }, [refValues, defaultChecked, name, setFieldValue]);

  return (
    <>
      <p>{ label } </p>
      { filteredRefValues.map((v) => {
        return (
          <SimpleCheckboxInput
            key={ v.id }
            label={ v.name }
            onChange={
              async () => {
                const refValuesToSet = refValues.map((k) => {
                  return { ...k, checked: k.id === v.id ? !k.checked : k.checked };
                });
                await setFieldValue(name, refValuesToSet.filter((k) => k.checked).map((l) => l.id));
              }
            }
            checked={ v.checked }
            noMarginBottom
            disabled={ loading }
          />
        );
      }) }
    </>
  );
};

export default RefValueListSelector;
